export default function ContentSeventh({ verticalTabsState }) {
  return (
    <div
      className={`content-7 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 7
          ? "max-h-[5000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h1 className="font-mont text-[36px] leading-[40px] my-[0.67em]">
        <strong>Easily Manage Suppliers</strong>
        <strong> & Purchase Orders</strong>
      </h1>

      <p className="text-[16px] mb-[25px] leading-[28px]">
        Improve your supply chain & inventory performance
      </p>

      <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
        <strong>Automate Your Purchasing Workflow</strong>
      </h2>

      <p className="text-[16px] my-[10px] leading-[20px]">
        Automatically send RFQs to your suppliers
      </p>

      <p className="mb-5 text-[16px]">
        Improve your purchase and inventory performance with procurement rules
        depending on stock levels, logistic rules, sales orders, forecast
        manufacturing orders, etc. Select different replenishment methods for
        each product depending on your manufacturing and delivery strategies.
      </p>

      <div className="pl-[15px]">
        <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
          <strong>Supplier Price Lists & Product Availability</strong>
        </h2>

        <p className="text-[16px] my-[10px] leading-[20px]">
          Make smart purchase decisions using the best prices.
        </p>

        <p className="mb-5 text-[16px]">
          Easily import suppliers' price lists and references to make smarter
          purchase decisions based on promotions, quantities and special
          contract conditions. Keep track of a product availability in your
          supplier’s stock and check your order status from within the app. You
          can even base your sales price on your supplier's prices.
        </p>

        <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
          <strong>Get The Best Offer With Purchase Tenders</strong>
        </h2>

        <p className="text-[16px] my-[10px] leading-[20px]">
          Get the best price by negotiating with several vendors.
        </p>

        <p className="mb-5 text-[16px]">
          Launch purchase tenders, integrate vendor's answers in the process and
          compare propositions. Choose the best offer and send purchase orders
          easily. Use reporting to analyze the quality of your vendors
          afterwards.
        </p>

        <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
          <strong>Get Statistics On Your Purchases</strong>
        </h2>

        <p className="text-[16px] my-[10px] leading-[20px]">
          Analyze, forecast and efficiently plan your orders
        </p>

        <h2 className="text-[30px] leading-[40px] mt-5 mb-[10px] font-mont">
          <strong>Manage several companies</strong>
        </h2>

        <p className="text-[16px] my-[10px] leading-[20px]">
          Save time and effort thanks to MEAN3's multi company rules.
        </p>
      </div>
    </div>
  );
}
